import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';

import { ClientServicesService } from 'app/entities/details/services/client-services.service';
import { ServiceType } from 'app/entities/details/services/client-service.model';
import { ClientService, ServiceValue } from 'app/entities/details/services/client-service.model';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { AddServiceRequest } from 'app/entities/details/services/addservices/add-service-request.model';

@Component({
    selector: 'add-client-service',
    templateUrl: './add-service.component.html'
})

/**
 * Component for adding client service.
 */
export class AddServiceComponent implements OnInit {
    clientId: number;
    servicesMap: Map<ServiceType, Array<ClientService>>;
    serviceTypeListCol1: Array<ServiceType> = [];
    serviceTypeListCol2: Array<ServiceType> = [];
    clientServicesLoaded: boolean;
    addedServices: Array<ServiceValue> = [];
    selectedServicesIdsList: Array<number> = [];
    selectedServices = new Map<ClientService, string>();
    updatingServices: boolean;
    selectedIndex: 0;

    constructor(
        public dialogRef: MdDialogRef<any>,
        private clientServicesService: ClientServicesService,
        private snackBarService: SnackBarService,
        private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        this.serviceTypeListCol1.push(ServiceType.TRUSTEE);
        this.serviceTypeListCol1.push(ServiceType.DOMICILE_SEC);
        this.serviceTypeListCol1.push(ServiceType.DOMICILE_PLUS);
        this.serviceTypeListCol1.push(ServiceType.MGT_SVC);
        this.serviceTypeListCol2.push(ServiceType.MEDIATE_SELLING);
        this.serviceTypeListCol2.push(ServiceType.PARTNER);
        this.serviceTypeListCol2.push(ServiceType.SUPPLY_CONDUIT_COMPANY);
        this.serviceTypeListCol2.push(ServiceType.OTHER);
        this.fetchClientServices();
    }

    fetchClientServices() {
        this.clientServicesService.listClientServices().subscribe(
            response => {
                this.servicesMap = response.arrResult;
                this.clientServicesLoaded = true;
                this.updateSelectedServicesList();
            },
            err => {
                this.callSnackBarService(err)
            }
        );
    }

    updateSelectedServicesList() {
        for (let i = 0; i < this.addedServices.length; i++) {
            this.selectedServicesIdsList.push(this.addedServices[i].clientServiceVO.id);
            this.selectedServices.set(this.addedServices[i].clientServiceVO, this.addedServices[i].description);
            const servicesFromMap = this.servicesMap[this.addedServices[i].clientServiceVO.category];
            for (let j = 0; j < servicesFromMap.length; j++) {
                if (servicesFromMap[j].id === this.addedServices[i].clientServiceVO.id) {
                    servicesFromMap[j].selected = true;
                    break;
                }
            }
        }
        this.cdr.detectChanges();
    }

    toggleServiceSelection(selectedService: ClientService) {
        for (let i = 0; i < this.selectedServicesIdsList.length; i++) {
            if (this.selectedServicesIdsList[i] === selectedService.id) {
                this.selectedServicesIdsList.splice(i, 1);
                const existingService = Array.from(this.selectedServices.keys()).find(service => {
                    return selectedService.id === service.id;
                });
                this.selectedServices.delete(existingService);
                return;
            }
        }
        this.selectedServicesIdsList.push(selectedService.id);
        this.selectedServices.set(selectedService, '');
        this.cdr.detectChanges();
    }

    getSelectedServices() {
        return Array.from(this.selectedServices.keys());
    }

    getSelectedServiceDescription(selectedService: ClientService) {
        return this.selectedServices.get(selectedService);
    }

    getServiceCategory(serviceCategory) {
        return ServiceType[serviceCategory];
    }

    updateDescription(event, selectedService) {
        this.selectedServices.set(selectedService, event.target.value);
    }

    updateServices() {
        this.updatingServices = true;
        const serviceValues = new Array<ServiceValue>();
        Array.from(this.selectedServices.keys()).forEach(clientService => {
            const serviceValue = new ServiceValue();
            serviceValue.clientServiceVO = clientService;
            serviceValue.description = this.selectedServices.get(clientService);
            serviceValues.push(serviceValue);
        });
        const addServiceRequest = new AddServiceRequest();
        addServiceRequest.clientId = this.clientId;
        addServiceRequest.services = serviceValues;
        this.clientServicesService.updateClientServices(addServiceRequest)
            .subscribe(
            success => {
                this.updatingServices = false;
                this.callSnackBarService(success);
                this.dialogRef.close(success.arrResult);
            },
            err => {
                this.updatingServices = false;
                this.callSnackBarService(err);
            }
            );
    }

    getServicesList(type) {
        if (!this.servicesMap) {
            return [];
        }
        // TODO(naveenkiran): Check whether there is a better way to traverse the map.
        switch (type) {
            case 'Act as trustee': return this.servicesMap['TRUSTEE'];
            case 'Domicile sec': return this.servicesMap['DOMICILE_SEC'];
            case 'Domicile plus': return this.servicesMap['DOMICILE_PLUS'];
            case 'Management Services': return this.servicesMap['MGT_SVC'];
            case 'Mediate in selling the company': return this.servicesMap['MEDIATE_SELLING'];
            case 'Partner': return this.servicesMap['PARTNER'];
            case 'Supplying a coduit company': return this.servicesMap['SUPPLY_CONDUIT_COMPANY'];
            case 'Other': return this.servicesMap['OTHER'];
        }
    }

    toggleTab(tabIndex) {
        this.selectedIndex = tabIndex;
    }

    selectedIndexChange(tabIndex) {
        this.selectedIndex = tabIndex;
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.UPDATE_CLIENT_SERVICES_SUCCESS,
            MessageService.UPDATE_CLIENT_SERVICES_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/details/services/addservices/add-service.component.ts